import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=6028f80a&"
import script from "./TabPanel.vue?vue&type=script&lang=js&"
export * from "./TabPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports